import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

    constructor(private http: HttpClient, private router: Router, private authService: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const headers = new HttpHeaders().set('authorization', `Bearer ${this.authService.getToken()}`);
        return this.http.get(`/api/auth`, { headers }).pipe(
            map((resp: any) => true),
            catchError((err: any) => {
                this.router.navigate(['login']).then();
                return of(false);
            })
        );
    }
}
